import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-payment',
  templateUrl: './error-payment.component.html',
  styleUrls: ['./error-payment.component.scss']
})
export class ErrorPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
